import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import './Sidebar.less';
import {
  ConfigProvider,
  Progress,
  Radio,
  Select,
  Slider,
  Switch,
  Upload,
  Input,
  Dropdown,
  Tooltip,
  Popover,
  Space,
} from 'antd';
import { SDService, projectController } from '@/api';
import aip_model_anime from '@/assets/texture/aip_model_anime.png';
import aip_model_claymate from '@/assets/texture/styles/aip_model_claymate.png';
import aip_model_claymate2 from '@/assets/texture/aip_model_claymate2.png';
import aip_model_fluffy from '@/assets/texture/styles/aip_model_fluffy.png';
import aip_model_handai123 from '@/assets/texture/aip_model_handai123.png';
import aip_model_juggernautXL from '@/assets/texture/aip_model_juggernautXL.png';
import aip_model_labubu from '@/assets/texture/aip_model_labubu.png';
import aip_model_realistic from '@/assets/texture/styles/aip_model_realistic.png';
import aip_model_yingshicheng from '@/assets/texture/aip_model_yingshicheng.png';
import aip_model_redhouse from '@/assets/texture/styles/aip_model_redhouse.png';
import aip_model_monster from '@/assets/texture/styles/aip_model_monster.png';
import { useDispatch, useSelector } from 'react-redux';

const styleImages = {
  aip_model_anime,
  aip_model_claymate,
  aip_model_claymate2,
  aip_model_fluffy,
  aip_model_handai123,
  aip_model_juggernautXL,
  aip_model_labubu,
  aip_model_realistic,
  aip_model_yingshicheng,
  aip_model_monster,
  aip_model_redhouse,
};
const { TextArea } = Input;
import Papa from 'papaparse';

import csvData from '@/config/texer_sd_settings.js'; // CRA/Vite 会自动处理为 URL
import toast from 'react-hot-toast';
import HoverButton from '@/components/HoverButton/HoverButton';
import { isFormatFile } from '@/utils/file';
import { useParams } from 'react-router-dom';
import { disableWebGLInput, enableWebGLInput, SetControlNetMode } from '@/utils/unityTool';
import { reportData } from '@/utils/trackingPoint';
import { info } from '@/utils/message';
// 笔刷二种状态的默认值
const inpaintingStrengthStatusValue = {
  inpaint: 0.5,
  normal: 1,
};

export default forwardRef(function Sidebar(props, ref) {
  const [models, setModels] = useState([]);
  const [quality, setQuality] = useState('stand');
  const [prompt, setPrompt] = useState('');
  const [generateButtonDisabled, setGenerateButtonDisabled] = useState(false);

  const [shape, setShape] = useState('depth');
  const [balance, setBalance] = useState('Balanced');
  const [controlWeight, setControlWeight] = useState(1);
  const [recordPage, setRecordPage] = useState(0);
  const [inpaintingStrength, setInpaintingStrength] = useState(0.5);
  const [showQulityMenu, setShowQulityMenu] = useState(false);
  const [showBanlanceMenu, setShowBanlanceMenu] = useState(false);
  const [showShapeMenu, setShowShapeMenu] = useState(false);
  const [isInpaint, setIsInpaint] = useState(false);
  const [inpaintingStrengthEnable, setInpaintingStrengthEnable] = useState(true);

  const textureState = useSelector((state) => state.texture);

  const [lastSeed, setLastSeed] = useState(-1);
  const { projectId } = useParams(); // 获取路径参数

  const [showPopStyle, setShowPopStyle] = useState(false);

  const [lockSeed, setLockSeed] = useState(false);
  const [thinkLoading, setThinkLoading] = useState(false);
  const [historyPrompts, setHistoryPrompts] = useState([]);

  const [shapes, setShapes] = useState([
    {
      label: 'Depth',
      key: 'depth',
    },
    {
      label: 'Normal',
      key: 'normal',
    },
  ]);
  const [balances, setBalances] = useState([
    {
      label: 'Prompt',
      key: 'More User Biased',
    },
    {
      label: 'Balance',
      key: 'Balanced',
    },
    {
      label: 'Structure',
      key: 'More Control Net Biased',
    },
  ]);

  const [qualitys, setQualitys] = useState([
    {
      label: 'Preview',
      key: 'preview',
    },
    {
      label: 'Standard',
      key: 'stand',
    },
  ]);

  const [styleList, setStyleList] = useState([]);

  const [selectStyle, setSelectStyle] = useState(null);

  useImperativeHandle(ref, () => ({
    changeInpant(inpaint) {
      if (inpaint) {
        setInpaintingStrength(inpaintingStrengthStatusValue['inpaint']);
      } else {
        setInpaintingStrength(inpaintingStrengthStatusValue['normal']);
      }
      setIsInpaint(inpaint);
    },
    resetInpant() {
      inpaintingStrengthStatusValue['inpaint'] = 0.5;
      inpaintingStrengthStatusValue['normal'] = 1;
    },
    settingLastSeed(val) {
      if (!lockSeed || lastSeed == -1) {
        setLastSeed(val);
      }
    },
    clickView() {
      clckView();
    },
    settingInpaintingStrengthEnable(value) {
      setInpaintingStrengthEnable(value);
      if (!inpaintingStrengthEnable) {
        setInpaintingStrength(1);
      }
    },
    settingGenerateButtonDisabled(value) {
      setGenerateButtonDisabled(value);
    },
  }));

  const clckView = () => {
    setShowBanlanceMenu(false);
    setShowShapeMenu(false);
    setShowQulityMenu(false);
  };

  useEffect(() => {
    queryStyles();
    queryHistoryPrompts();
  }, []);

  const onTextareaKeyUp = (e) => {
    if (e.shiftKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      if (!historyPrompts.length) {
        return;
      }
      if (e.key === 'ArrowDown') {
        settingPrompt(1);
      } else if (e.key === 'ArrowUp') {
        settingPrompt(-1);
      }
      e.preventDefault();
    }
  };

  const settingPrompt = (add) => {
    if (!historyPrompts.length) {
      return;
    }
    let index = historyPrompts.indexOf(prompt);

    index = (index + add + historyPrompts.length) % historyPrompts.length; // 向上循环

    setPrompt(historyPrompts[index]);
  };

  const queryStyles = async () => {
    const { data } = Papa.parse(csvData, {
      header: true,
      skipEmptyLines: true,
    });
    const list = await queryLoras();
    const modelList = await queryModelList();
    data.forEach((element, i) => {
      element.image = styleImages[element['key']];
      const loraName = element.loras.split(':');
      element.controlNets = element['control net'].split(',');

      const depth = element.controlNets[0];
      const normal = element.controlNets[1];

      const lora = list.find((item) => item.name === loraName);
      const depthModel = modelList.find((item) => item.includes(depth));
      const normalModel = modelList.find((item) => item.includes(normal));

      if (lora) {
        element.loras = loraName.replace(loraName, lora.alias);
      }
      if (depthModel) {
        element.controlNets[0] = depthModel;
      }
      if (normalModel) {
        element.controlNets[1] = normalModel;
      }
      if (i == 0) {
        // const pv = localStorage.getItem('prompt_' + i);
        // if (pv) {
        //   setPrompt(pv);
        // } else {
        // }
      }
      if (element.model === 'realisticvisionv51_v51vae') {
        element.show = true;
      } else {
        element.show = false;
      }
    });
    setSelectStyle(data[0]);
    setStyleList(data);
  };
  const queryLoras = async () => {
    try {
      const { raw_output } = await SDService.submitTaskAndResponse(
        '/sdapi/v1/loras',
        {},
        () => {},
        {},
        'GET',
      );
      return raw_output;
      // setModels(res.raw_output);
    } catch (error) {
      console.error(error);
    }
  };

  const queryHistoryPrompts = async () => {
    try {
      const { data } = await projectController.getPrompt(projectId);
      setHistoryPrompts(data);
      if (data.length > 0) {
        setPrompt(data[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const queryModels = async () => {
    try {
      const { raw_output } = await SDService.submitTaskAndResponse(
        '/sdapi/v1/sd-models',
        {},
        () => {},
        {},
        'GET',
      );
      return raw_output;
    } catch (error) {
      console.error(error);
    }
  };

  const queryModelList = async () => {
    try {
      const { raw_output } = await SDService.submitTaskAndResponse(
        '/controlnet/model_list',
        {},
        () => {},
        {},
        'GET',
      );
      return raw_output.model_list;
    } catch (error) {
      console.error(error);
    }
  };

  // 生成
  const generate = async () => {
    const promptValue = selectStyle
      ? (selectStyle.loras ? `<lora:${selectStyle.loras}>,` : '') +
        (selectStyle.prompt ? selectStyle.prompt + ',' : '') +
        prompt
      : '';
    const seedValue = (!lockSeed ? -1 : lastSeed) || -1;
    console.log('seedValue', seedValue);
    reportData('generate', {
      guidance: shape,
      type: balances.find((item) => item.key === balance).label,
      'num-strength': inpaintingStrength,
      prompt: promptValue,
      seed: lockSeed ? 'lock' : 'unlock',
    });

    if (generateButtonDisabled) {
      return;
    }
    if (!prompt) {
      return;
    }

    if (!selectStyle) {
      info('Please choose style');
      return;
    }

    setGenerateButtonDisabled(true);

    const first = historyPrompts.length ? historyPrompts[0] : undefined;
    if (first != prompt) {
      // 把新元素放在最前面
      historyPrompts.unshift(prompt);
    }

    // 超过限制，删除最后一个
    if (historyPrompts.length > 5) {
      historyPrompts.pop();
    }

    projectController.savePrompt({
      body: {
        prompts: historyPrompts,
      },
      projectId,
    });

    props.onGenerate({
      prompt:
        (selectStyle.loras ? `<lora:${selectStyle.loras}>,` : '') +
        (selectStyle.prompt ? selectStyle.prompt + ',' : '') +
        prompt,
      negative_prompt: selectStyle.neg_prompt,
      sampler_name: selectStyle.sampler,
      cfg_scale: selectStyle.cfg * 1,
      width: quality == 'preview' ? 512 : 1024,
      height: quality == 'preview' ? 512 : 1024,
      seed: seedValue,
      hr_sampler_name: selectStyle.sampler,
      denoising_strength: inpaintingStrength,
      model: shape == 'depth' ? selectStyle.controlNets[0] : selectStyle.controlNets[1],
      //  model: "control_v11f1p_sd15_depth_fp16 [4b72d323]",
      weight: controlWeight,
      control_mode: balance,
    });
  };
  const propsUploadMesh = {
    name: 'file',
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const propsUploadTexture = {
    name: 'file',
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const getLabel = (items, key) => {
    const item = items.find((item) => item.key == key);
    if (item) {
      return item.label;
    }
    return '';
  };

  const think = async () => {
    if (!prompt) {
      return;
    }
    try {
      if (thinkLoading) {
        return;
      }
      setThinkLoading(true);
      const { code, data } = await projectController.completeText({
        body: {
          text: prompt,
        },
      });
      if (code == 0) {
        if (data.length > 300) {
          setPrompt(data.substring(0, 300));
        } else {
          setPrompt(data);
        }
      }
      setThinkLoading(false);
    } catch (error) {
      console.error(error);
      setThinkLoading(false);
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-content scrollbar-thin scrollbar-track-transparent">
        <div className="sidebar-content-wrapper">
          <div className="block2">
            {/* <div className="buttons">
              <Upload
                beforeUpload={() => false}
                accept=".jpg,.png,.jpeg"
                showUploadList={false}
                onChange={(info) => {
                  const isLt2M = info.file.size / 1024 / 1024 < 10;
                  if (!isLt2M) {
                    toast('Less than 10MB');
                    return;
                  }
                  if (isFormatFile(info.file, ['.jpg', '.png', '.jpeg'])) {
                    props.onUploadTexture(info.file);
                  } else {
                    toast('Invalid format');
                  }
                }}
                style={{ width: '100%' }}>
                <div className="upload-texture">Upload Texture</div>
              </Upload>
            </div> */}
            <div className="title">Styles</div>

            <Popover
              arrow={false}
              trigger="click"
              open={showPopStyle}
              color="#222222"
              placement="leftTop"
              onOpenChange={(value) => {
                reportData('click-lora');
                setShowPopStyle(!showPopStyle);
              }}
              content={
                <div className="select-style-list-wrapper">
                  <div className="select-style-list-wrapper-header">
                    <div className="name">Styles</div>
                    <div
                      className="close"
                      onClick={() => {
                        setShowPopStyle(false);
                      }}></div>
                  </div>
                  <div className="select-style-list" onClick={() => {}}>
                    {styleList
                      .filter((item) => item.show)
                      .map((item) => {
                        return (
                          <div
                            onClick={() => {
                              setShowPopStyle(false);
                              setSelectStyle(item);
                              reportData('select-lora', {
                                'lora-name': item.name,
                              });
                            }}
                            className={'style-item ' + (selectStyle == item ? 'checked' : '')}
                            key={item.name}>
                            <img src={item.image}></img>
                            <div className="name">{item.name}</div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              }>
              {selectStyle && (
                <div className="select-style">
                  <img className="select-style-img" src={selectStyle.image}></img>
                  <div className="select-style-name">{selectStyle.name}</div>
                  <div className="select-style-expand"></div>
                </div>
              )}
            </Popover>
            <div className="title-row">
              <div className="title-name">Texture Guidance</div>
              <Tooltip title="Depth is biased toward global shape, Normal is biased toward local detail.">
                <div className="help"></div>
              </Tooltip>
            </div>

            <Radio.Group
              value={shape}
              onChange={(e) => {
                setShape(e.target.value);

                SetControlNetMode(props.sendMessage, e.target.value === 'normal' ? 1 : 0);
              }}
              buttonStyle="solid">
              {shapes.map((item) => {
                return (
                  <Radio.Button
                    onClick={() => {
                      if (item.key === 'depth') {
                        reportData('click-depth');
                      } else {
                        reportData('click-normal');
                      }
                    }}
                    key={item.key}
                    value={item.key}>
                    {item.label}
                  </Radio.Button>
                );
              })}
            </Radio.Group>
            <div className="title-row">
              <div className="title-name">Control Type</div>
              <Tooltip title="Choose whether you want the generated texture to lean more toward the prompt or toward the model’s structure.">
                <div className="help"></div>
              </Tooltip>
            </div>
            <Radio.Group
              value={balance}
              onChange={(e) => {
                const balance = e.target.value;

                setBalance(balance);
              }}
              buttonStyle="solid">
              {balances.map((item) => {
                return (
                  <Radio.Button
                    onClick={() => {
                      console.log('e222', item.key);
                      if (item.key === 'More User Biased') {
                        reportData('click-prompt');
                      } else if (item.key === 'Balanced') {
                        reportData('click-balance');
                      } else if (item.key === 'More Control Net Biased') {
                        reportData('click-structure');
                      }
                    }}
                    key={item.key}
                    value={item.key}>
                    {item.label}
                  </Radio.Button>
                );
              })}
            </Radio.Group>

            {/* <Dropdown
              menu={{
                items: qualitys,
                onClick: (v) => {
                  setShowQulityMenu(false);
                  setQuality(v.key);
                  console.log('change v', v);
                },
              }}
              open={showQulityMenu}
              onClick={(event) => {
                clckView();
                event.stopPropagation();
                setShowQulityMenu(!showQulityMenu);
              }}
              trigger={['click']}>
              <div className="dropdown-select">
                <span className="dropdown-select-title">{getLabel(qualitys, quality)}</span>
                <div className={'dropdown-select-icon ' + (showQulityMenu ? 'expand' : '')}></div>
              </div>
            </Dropdown> */}
            {/* <div className="inpainting">
              <div className="title">Control Weight</div>
              <Slider
                value={controlWeight}
                min={0}
                max={1}
                step={0.01}
                onChange={(value) => {
                  console.log('value', value);
                  setControlWeight(value);
                }}></Slider>
            </div> */}

            <div className="inpainting">
              <div className="title-row">
                <div className="title-name">Inpainting Strength</div>
                <Tooltip title="Select the AI contribution level: 0 preserves more of the original texture, while 1 emphasizes AI-driven creation.">
                  <div className="help"></div>
                </Tooltip>
              </div>
              <Slider
                step={0.01}
                min={0}
                max={1}
                value={inpaintingStrength}
                onChange={(v) => {
                  if (!inpaintingStrengthEnable && !textureState.isInpainting) {
                    toast.remove(); // 会移除页面上所有 toast
                    info(
                      'The current model has no texture. To ensure the quality of the initial generation, the Inpainting strength is set to 1 by default.',
                      {
                        duration: 2000, // 显示 2 秒
                        style: {
                          transition: 'none', // 禁止 CSS transition
                          animation: 'none', // 禁止动画
                        },
                      },
                    );
                    setInpaintingStrength(1);
                    return;
                  }
                  reportData('strength', {
                    'num-strength': v,
                  });
                  if (isInpaint) {
                    inpaintingStrengthStatusValue['inpaint'] = v;
                  } else {
                    inpaintingStrengthStatusValue['normal'] = v;
                  }
                  setInpaintingStrength(v);
                }}></Slider>
            </div>
            <div className="text-area">
              <TextArea
                style={{
                  resize: 'none',
                  border: 'none',
                  paddingBottom: 30,
                  backgroundColor: '#171717',
                }}
                className="prompt-input scrollbar-thin scrollbar-track-transparent"
                placeholder="Prompt( eg.A 3D felt fiber house, soft smooth lighting, soft colors, 3D Blender render)..."
                // onPaste={(e) => {
                //   console.log('prompte', e.target.value);
                //   const s = prompt.split(' ');
                //   let value = e.target.value;
                //   if (s.length > 75) {
                //     value = s.slice(0, 75).join(' ');
                //   }
                //   setPrompt(value);
                // }}
                onClick={() => {}}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.length > 300) {
                    value = value.substring(0, 300);
                  }
                  setPrompt(value);
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  disableWebGLInput(props.sendMessage);
                }}
                onBlur={(e) => {
                  e.stopPropagation();
                  enableWebGLInput(props.sendMessage);
                }}
                onKeyUp={(e) => {
                  console.log('onKeyUp', e);
                  onTextareaKeyUp(e);
                  e.stopPropagation();
                }}
                value={prompt}
                rows={4}></TextArea>

              <div className="textarea-bottom">
                <div
                  className={'think ' + (!prompt ? 'disable' : '')}
                  style={{ display: 'flex' }}
                  onClick={() => {
                    think();
                  }}>
                  <div className={'icon ' + (thinkLoading ? 'loading' : '')}></div>
                  <div>Elaborate</div>
                </div>

                <div
                  className="last-prompt"
                  onClick={() => {
                    settingPrompt(-1);
                  }}></div>
                <div
                  className="next-prompt"
                  onClick={() => {
                    settingPrompt(1);
                  }}></div>
                <div style={{ flex: 1 }}></div>
                <div className="count">{prompt.length}/300</div>
              </div>
            </div>
            {/* <div className="record">
              <span className="record-title">Record</span>
              {new Array(5).fill(0).map((item, i) => {
                return (
                  <div
                    onClick={() => {
                      setRecordPage(i);
                      const pv = localStorage.getItem('prompt_' + i);
                      if (pv) {
                        setPrompt(pv);
                      } else {
                        setPrompt('');
                      }
                    }}
                    className={'record-page ' + (recordPage === i ? 'active' : '')}
                    key={i}>
                    {i + 1}
                  </div>
                );
              })}
            </div> */}

            <div className="random">
              <span className="random-title">Lock Seed</span>
              <Tooltip title="Locking the seed allows all subsequent textures to maintain consistency with this style.">
                <div className="help"></div>
              </Tooltip>

              <div style={{ flex: 1 }}></div>
              <Switch
                value={lockSeed}
                onChange={(v) => {
                  reportData('click-lockseed');
                  setLockSeed(v);
                }}></Switch>
            </div>
          </div>
        </div>
      </div>
      <div
        className={'generate-button ' + (!prompt || generateButtonDisabled ? 'disabled' : '')}
        onClick={() => {
          generate();
        }}>
        Generate Texture
      </div>
    </div>
  );
});
